<template>
  <li class="list-group-item" :class="context">
    <strong class="session-status">{{ statusKey }}:</strong>
    <transition name="bounce" mode="out-in">
      <span class="session-status" :key="statusValue">&nbsp; {{ statusValue }} &nbsp;</span>
    </transition>
    <span class="badge badge-pill badge-info session-status" v-if="exposureTime">{{ exposureTime }} seconds left</span>
  </li>
</template>

<script>
  export default {
    name: 'statusItem',
    props: ['statusKey', 'statusValue', 'context', 'exposureTime'],
    data: function() {
      return {
      };
    }
  };
</script>